export default function IconHyperlink({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.53 0.61 16.95 16.95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M7.14674 13.5688L6.49162 14.2239C5.89842 14.8171 5.09386 15.1504 4.25494 15.1504C3.41602 15.1504 2.61147 14.8171 2.01826 14.2239C1.42506 13.6307 1.0918 12.8261 1.0918 11.9872C1.0918 11.1483 1.42506 10.3437 2.01826 9.75053L5.37328 6.39481C5.93577 5.83105 6.69021 5.50021 7.48596 5.46835C8.2817 5.4365 9.06017 5.70598 9.66593 6.22297C10.2717 6.73997 10.6601 7.46644 10.7537 8.2573C10.8473 9.04816 10.6391 9.84522 10.1707 10.4893"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9807 4.47807L11.5079 3.95088C12.1011 3.35767 12.9057 3.02441 13.7446 3.02441C14.16 3.02441 14.5713 3.10623 14.9551 3.26519C15.3388 3.42416 15.6875 3.65715 15.9813 3.95088C16.275 4.2446 16.508 4.59331 16.6669 4.97708C16.8259 5.36085 16.9077 5.77217 16.9077 6.18756C16.9077 6.60295 16.8259 7.01427 16.6669 7.39804C16.508 7.78181 16.275 8.13051 15.9813 8.42424L12.6262 11.7793C12.0636 12.3428 11.3092 12.6734 10.5135 12.705C9.71785 12.7367 8.93952 12.4671 8.33392 11.9501C7.72831 11.433 7.34 10.7066 7.2465 9.91582C7.153 9.12503 7.3612 8.32808 7.82953 7.68407"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
